/* Essentzia – barra spedizione gratuita: aggiorna testo e barra quando cambia il carrello */
(function () {
  function fmt(cents, lang) {
    return new Intl.NumberFormat(lang === 'en' ? 'en-IE' : 'it-IT', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  var lastCart = null;
  var LANG = (document.documentElement.lang || 'it').slice(0, 2) === 'en' ? 'en' : 'it';

  /* Carrello laterale e pagina carrello: la barra viene inserita qui (il tema ridisegna il carrello, quindi la reinseriamo se sparisce) */
  function box(ctx) {
    var d = document.createElement('div');
    d.className = 'ess-fs ess-fs--' + ctx + ' is-empty is-loading';
    d.setAttribute('data-ess-fs', '');
    d.setAttribute('role', 'status');
    d.setAttribute('aria-live', 'polite');
    d.dataset.context = ctx;
    d.dataset.threshold = '4000';
    d.dataset.lang = LANG;
    d.innerHTML = '<p class="ess-fs__text" data-ess-fs-text></p><div class="ess-fs__track" aria-hidden="true"><span class="ess-fs__fill" data-ess-fs-fill></span></div>';
    return d;
  }
  function mount() {
    var added = false;
    var head = document.querySelector('cart-drawer .drawer__header');
    if (head && !(head.nextElementSibling && head.nextElementSibling.matches('[data-ess-fs]'))) {
      head.insertAdjacentElement('afterend', box('drawer')); added = true;
    }
    var title = document.querySelector('cart-items .title-wrapper-with-link');
    if (title && !(title.nextElementSibling && title.nextElementSibling.matches('[data-ess-fs]'))) {
      title.insertAdjacentElement('afterend', box('page')); added = true;
    }
    if (added && lastCart) render(lastCart);
  }

  function render(cart) {
    if (!cart || cart.currency !== 'EUR') return;
    lastCart = cart;
    document.querySelectorAll('[data-ess-fs]').forEach(function (el) {
      var soglia = parseInt(el.dataset.threshold, 10) || 4000;
      var lang = el.dataset.lang;
      var ctx = el.dataset.context;
      var tot = cart.total_price;
      var manca = Math.max(soglia - tot, 0);
      var perc = Math.min(Math.round((tot / soglia) * 100), 100);
      var t;
      if (cart.item_count === 0) {
        t = lang === 'en' ? 'Free shipping in Italy on orders over <strong>€40</strong>' : 'Spedizione gratuita in Italia sopra i <strong>40 €</strong>';
      } else if (manca === 0) {
        t = lang === 'en' ? "You've got free shipping in Italy" : 'Hai la spedizione gratuita in Italia';
      } else if (ctx === 'product') {
        t = lang === 'en'
          ? 'Free shipping in Italy over <strong>€40</strong>. Add <strong>' + fmt(manca, lang) + '</strong> more to get it.'
          : 'Spedizione gratuita in Italia sopra i <strong>40 €</strong>. Ti mancano <strong>' + fmt(manca, lang) + '</strong>.';
      } else {
        t = lang === 'en'
          ? 'Add <strong>' + fmt(manca, lang) + '</strong> more for free shipping in Italy'
          : 'Ti mancano <strong>' + fmt(manca, lang) + '</strong> per la spedizione gratuita in Italia';
      }
      var txt = el.querySelector('[data-ess-fs-text]');
      if (txt && txt.innerHTML !== t) txt.innerHTML = t;
      var fill = el.querySelector('[data-ess-fs-fill]');
      if (fill) fill.style.width = perc + '%';
      el.classList.toggle('is-free', manca === 0 && cart.item_count > 0);
      el.classList.toggle('is-empty', cart.item_count === 0);
      el.classList.remove('is-loading');
    });
  }

  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 150);
  }

  /* Ogni chiamata al carrello (aggiungi, cambia quantità, rimuovi, app abbonamenti) fa ricalcolare la barra */
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { refresh(); }).catch(function () {});
    }
    return p;
  };

  document.addEventListener('DOMContentLoaded', function () {
    mount();
    new MutationObserver(function () { mount(); }).observe(document.body, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    refresh();
  });
  /* Tornando indietro col browser la pagina può essere in cache: ricalcola */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
